import { useSEO, generateWebPageSchema, generateBreadcrumbSchema, generateServiceSchema } from '@/utils/seo';
import ServicePageLayout, { ServicePageConfig } from '@/pages/service-common/ServicePageLayout';

/* ─── Hero Background ─── */
const HERO_IMG = 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20golden%20data%20visualization%20charts%20and%20flowing%20analytics%20particles%20on%20deep%20navy%20blue%20background%20minimal%20sophisticated%20high-end%20corporate%20aesthetic%20soft%20glowing%20no%20text&width=1920&height=800&seq=datahero1&orientation=landscape';

const config: ServicePageConfig = {
  pageLabel: 'データマーケティング',
  heroImage: HERO_IMG,
  tag: 'Data Marketing',
  title: <>データを<br />マーケティングの武器に</>,
  subtitle: '38TBのデータ分析と1,517本のカスタムレポート作成実績。先進的な分析技術とマーケティング知見を融合し、ROIを最大化します。',
  icon: 'ri-database-line',
  services: [
    { icon: 'ri-user-2-line', title: '顧客アナリティクス', desc: '顧客行動と嗜好を深く分析し、パーソナライズされた体験設計に活用します。' },
    { icon: 'ri-eye-2-line', title: '予測モデリング', desc: '機械学習を活用してトレンドや顧客行動を予測し、先手を打った施策を実行します。' },
    { icon: 'ri-route-line', title: 'マーケティングアトリビューション', desc: 'どのチャネルが成果を生んでいるかを正確に把握し、予算配分を最適化します。' },
    { icon: 'ri-focus-2-line', title: 'セグメンテーション・ターゲティング', desc: '高価値顧客セグメントを特定し、最適なメッセージとタイミングでアプローチします。' },
    { icon: 'ri-dashboard-line', title: 'ダッシュボード・レポーティング', desc: 'マーケティングパフォーマンスをリアルタイムで可視化するダッシュボードを構築します。' },
    { icon: 'ri-server-line', title: 'データ基盤構築', desc: 'スケーラブルなデータ収集・蓄積・活用の仕組みを設計・実装します。' },
  ],
  stats: [
    { number: '38TB', label: 'データ分析量' },
    { number: '1,517', label: 'カスタム分析レポート' },
    { number: '191', label: 'Tableauダッシュボード' },
    { number: '3.2x', label: '平均ROI改善率' },
  ],
  benefits: [
    '38TBのデータ分析実績に裏打ちされた確かな分析力と知見',
    '自信を持ったデータドリブンな意思決定で施策の精度を向上',
    '継続的な最適化によりマーケティングROIを最大化',
    'データの中に隠れた機会を発掘し、競合を先取りした施策を実行',
    'スケールを問わず、パーソナライズされた顧客体験をリアルタイムで提供',
    '複雑なデータを分かりやすく可視化し、組織全体の意思決定を高速化',
  ],
};

export default function DataMarketingPage() {
  useSEO({
    title: '東京 データマーケティング TradFit株式会社 | データ分析・ROI最大化',
    description: 'TradFit株式会社のデータマーケティングサービス。38TBのデータ分析実績と先進的な分析技術で、マーケティングROIを最大化します。',
    keywords: 'データマーケティング, データ分析, ROI最大化, 顧客アナリティクス, 東京',
    path: '/data-marketing',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateWebPageSchema('データマーケティング | TradFit株式会社', 'TradFit株式会社のデータマーケティングサービス。', '/data-marketing'),
        generateBreadcrumbSchema([{ name: 'ホーム', path: '/' }, { name: '事業内容', path: '/business' }, { name: 'データマーケティング', path: '/data-marketing' }]),
        generateServiceSchema('データマーケティング', '38TBのデータ分析実績と先進的な分析技術によるデータマーケティングサービス。'),
      ],
    },
  });
  return <ServicePageLayout config={config} />;
}
